import React from 'react'
import './header.css'
const Header = ({title}) => {
  return (
    <h3 className='header'>{title}</h3>
  )
}

export default Header